export const organizationsList = {
  WAFFY_ORGANIZATIONS: "منظمات وفّي",
  ORGANIZATIONS_LIST: "قائمة المنظمات",
  CODE: "كود",
  NAME: "إسم",
  FEES: "رسوم",
  LOGO: "لوجو",
  WEBSITE_URL: "لينك الموقع",
  DESCRIPTIONS: "تفاصيل",
  ADD_ORGANIZATION: "إضافة منظمة",
  EDIT_ORGANIZATION: "تعديل المنظمة",
  FIND_A_ORGANIZATION: "… اﺑﺤﺚ ﻋﻦ منظمة",
  ADD_A_ORGANIZATION: "إضافة",
  EDIT_A_ORGANIZATION: "تعديل",
};
